// removed by extract-text-webpack-plugin
module.exports = {"tagCloud":"antd-pro-charts--tag-cloud-tagCloud"};


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/src/components/Charts/TagCloud/index.less
// module id = 591
// module chunks = 0